import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { reduxForm, Field } from "redux-form";
import format from "date-fns/format";
import { toastr } from "react-redux-toastr";
import { moneyFormat } from "../../app/common/util/moneyFormat";
import TextInput from "../../app/common/form/TextInput";
import TextArea from "../../app/common/form/TextArea";
import classes from "./selectedTransaction.module.css";
import { openModal } from "../modals/modalActions";

// NO module-level validators (matches deposits pattern)

const selectedTransaction = (props) => {
  const { transaction, reversalTransaction, openModal } =
    props;

  // Local state for form values (matches deposits pattern: line 37-38)
  const [reversalAmount, setReversalAmount] = useState("");
  const [reversalReason, setReversalReason] = useState("");

  console.log("reversalTransaction", reversalTransaction);

  // onClick handler with validation (matches deposits pattern: lines 177-188)
  const handleReversalClick = () => {
    if (!reversalAmount) {
      toastr.error("Oops", "Please enter a reversal amount");
      return;
    }

    if (!reversalReason) {
      toastr.error("Oops", "Please enter a reversal reason");
      return;
    }

    const entered = parseFloat(reversalAmount);
    const original = parseFloat(
      transaction && transaction.transactionAmount
        ? transaction.transactionAmount
        : 0,
    );

    if (isNaN(entered)) {
      toastr.error("Oops", "Reversal amount must be a valid number");
      return;
    }

    if (entered <= 0) {
      toastr.error("Oops", "Reversal amount must be greater than 0");
      return;
    }

    if (entered > original) {
      toastr.error(
        "Oops",
        `Reversal amount cannot exceed original amount (${moneyFormat(original)})`,
      );
      return;
    }

    openModal("ReversalConfirmationModal", {
      transaction: transaction,
      reversalAmount: reversalAmount,
      reversalReason: reversalReason,
      originalAmount: transaction.transactionAmount,
    });
  };

  const transactionDetail = (transaction) => {
    switch (transaction.transactionType) {
      case "Sale":
        return transaction.saleType === "Airtime"
          ? transaction.saleType
          : transaction.saleType;

        break;
      case "Deposit":
        return transaction.depositType === "Bank Deposit"
          ? transaction.bank
          : transaction.depositType;
        break;
      case "Reversal":
        return transaction.reversalType;
        break;
      case "Withdrawal":
        return transaction.withdrawalType;
        break;
      default:
        return transaction.saleType;
    }
  };

  return (
    <div label="Transactions">
      <header className={classes.TabHeader}>
        <div className={classes.PageHeader}>
          <form>
            {/* <h4>
              Selected Transaction:
              <span className={"semi-bold"}>Transaction Details</span>
            </h4> */}

            <div className={classes.Header}>
              {/* <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                <div
                  className={"col-md-6"}
                  style={{ justifyContent: "flex-start", display: "flex" }}
                >
                  {transaction.transactionType}
                </div>
                <div
                  className={"col-md-6"}
                  style={{ justifyContent: "flex-end", display: "flex" }}
                >
                  {format(
                    transaction.transactionDateTime.toDate(),
                    "YYYY-MM-DD  HH:mm:ss"
                  )}
                </div>
              </div> */}
              <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                <div
                  className={"col-md-6"}
                  style={{ justifyContent: "flex-start", display: "flex" }}
                >
                  <h5>{transactionDetail(transaction)}</h5>
                </div>
                <div
                  className={"col-md-6"}
                  style={{ justifyContent: "flex-end", display: "flex" }}
                >
                  <h5>{moneyFormat(transaction.transactionAmount)}</h5>
                </div>
              </div>

              {reversalTransaction && reversalTransaction[0] ? (
                <Fragment>
                  <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                    <div className={"col-md-12"}>
                      <h5>
                        <strong>Status:</strong> Transaction Reversed
                      </h5>
                    </div>
                  </div>
                  <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                    <div className={"col-md-12"}>
                      <h5>
                        <strong>Date:</strong>{" "}
                        {format(
                          reversalTransaction[0].transactionDateTime.toDate(),
                          "YYYY-MM-DD  HH:mm:ss",
                        )}
                      </h5>
                    </div>
                  </div>
                  <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                    <div className={"col-md-12"}>
                      <h5>
                        <strong>Reason:</strong>
                        {` ${reversalTransaction[0].reversalReason}`}
                      </h5>
                    </div>
                  </div>
                </Fragment>
              ) : transaction.transactionType === "Reversal" ? (
                <Fragment>
                  <br />
                  <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                    <div className={"col-md-12"}>
                      <h5>
                        <strong>Reason:</strong>
                        {` ${transaction.reversalReason}`}
                      </h5>
                    </div>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <br />
                  {/*PARTIAL REVERSAL AMOUNT */}
                  <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                    <div className={"col-md-12"}>
                      <Field
                        label="Reversal Amount"
                        name="reversal_amount"
                        component={TextInput}
                        type="text"
                        className={"form-control"}
                        placeholder="Amount to Reverse"
                        onChange={(e) => setReversalAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className={"row"} style={{ lineHeight: "3.8rem" }}>
                    <div className={"col-md-12"}>
                      <Field
                        label="Reversal Reason"
                        name="reversal_reason"
                        component={TextArea}
                        type="text"
                        className={"form-control"}
                        placeholder="Reason for Reversal"
                        onChange={(e) => setReversalReason(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className={"p-t-20 sm-m-t-20 bg-white clearfix"}>
                    <ul className={"pager wizard no-style"}>
                      <li className="next">
                        <button
                          className={"btn btn-primary btn-cons"}
                          type="button"
                          onClick={handleReversalClick}
                        >
                          <span>Reverse Transaction</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </Fragment>
              )}
            </div>
          </form>
        </div>
      </header>
    </div>
  );
};

const actions = {
  openModal,
};

const mapStateToProps = (state) => ({
  reversalTransaction: state.firestore.ordered.reversalTransaction,
  enableReinitialize: true,
});

// export default connect(
//   mapStateToProps,
//   actions
// )(
//   reduxForm({
//     form: "enableUserForm",
//     destroyOnUnmount: true,
//     forceUnregisterOnUnmount: true,
//     validate
//   })(selectedTransaction)
// );

export default compose(
  firestoreConnect((props) => {
    // Guard: follows pattern from deposits/transactions/details/detail.jsx
    if (!props.transaction || !props.transaction.id) return [];

    return [
      {
        collection: "transactions",
        storeAs: "reversalTransaction",
        where: ["reversalReference", "==", props.transaction.id],
      },
    ];
  }),
  connect(mapStateToProps, actions),
)(
  reduxForm({
    form: "enableUserForm",
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    // NO validate - matches deposits pattern
  })(selectedTransaction),
);
